'use client';

import React from 'react';

export const useEffectDidMount = (effect: React.EffectCallback): void => {
  React.useEffect(() => {
    return effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
